import type { Theme } from '@mui/material';

const extralight = 200;
// const light = 300;
const regular = 400;
const medium = 500;

const typography = (fontFamily: string): Theme['typography'] => ({
  fontFamily:
    typeof fontFamily === 'undefined' || fontFamily === ''
      ? [
          '"Helvetica Now Text"',
          'Inter',
          'sans-serif',
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Roboto',
          '"Helvetica Neue"',
          'Arial',
          'sans-serif',
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
        ].join(',')
      : fontFamily,
  fontSize: 14,
  h1: {
    fontSize: '60px',
    fontWeight: extralight,
    lineHeight: '64px',
  },
  h2: {
    fontSize: '20px',
    fontWeight: regular,
    lineHeight: '24px',
  },
  h3: {
    // todo: change to matter
    fontSize: '16px',
    fontWeight: medium,
    lineHeight: '24px',
  },
  h4: {
    fontSize: '13px',
    fontWeight: medium,
    lineHeight: '20px',
  },
  h5: {
    fontSize: '1.125rem',
    fontWeight: medium,
    lineHeight: 1.5556,
  },
  h6: {
    fontSize: '0.9375rem',
    fontWeight: medium,
    lineHeight: 1.46667,
  },
  // Label
  subtitle1: {
    fontSize: '13px',
    lineHeight: '20px',
    fontWeight: regular,
  },
  // Tiny Label
  subtitle2: {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: regular,
  },
  // Paragraph
  body1: {
    fontSize: '13px',
    lineHeight: '20px',
    fontWeight: regular,
  },
  // Tiny Paragraph
  body2: {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: regular,
  },
  button: {
    fontSize: '13px',
    lineHeight: '20px',
    fontWeight: medium,
    textTransform: 'none',
  },
  caption: {
    fontSize: '0.8125rem',
    lineHeight: 1.3846154,
    letterSpacing: '0.4px',
  },
  // Table titles
  overline: {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: regular,
  },
  fontWeightBold: 700,
  fontWeightLight: 300,
  fontWeightMedium: 500,
  fontWeightRegular: 400,
  htmlFontSize: 14,
  pxToRem: (size: number) => `${size / 14}rem`,
});

export default typography;
